import React from 'react';
import PublicShell from '@/components/public/PublicShell';

export default function About() {
  return (
    <PublicShell>
      <h1 className="text-4xl font-bold text-slate-900 mb-6">About World Check 360</h1>
      <div className="space-y-4 text-slate-700 leading-relaxed">
        <p>
          World Check 360 is a KYC and AML screening platform that helps organisations check individuals,
          companies, vessels and securities against global risk data in seconds. A single screening searches
          sanctions lists such as OFAC, the UN, the EU and the UK, politically exposed persons (PEP) databases,
          debarment lists from the World Bank and other development banks, law-enforcement and warrant data,
          ultimate beneficial ownership records, and adverse media.
        </p>
        <p>
          Results are combined into a clear risk rating with match confidence scores, red flags and suggested
          follow-up actions, so compliance teams can focus on the cases that matter. Bulk screening, audit logs,
          team roles and downloadable reports make it practical for daily onboarding and ongoing monitoring.
        </p>
        <p>
          The platform is built for compliance officers, KYC analysts, risk managers, banks, fintechs, shipping
          and trade companies, law firms and any business that must meet anti-money-laundering and sanctions
          obligations without the cost of a large legacy system.
        </p>
        <p>
          World Check 360 is built by a team of compliance and technology professionals focused on making
          reliable, affordable due diligence available to organisations of every size, from startups on the
          free Starter plan to enterprises running high-volume screening.
        </p>
      </div>
    </PublicShell>
  );
}